module.exports = __webpack_public_path__ + "static/media/ceremony.2572a308.svg";